import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#202020",
      d: "M10.978 3.086c.333-.334.573-.574.82-.75a3.61 3.61 0 0 1 4.189 0c.247.176.487.416.82.75l.109.108c.333.334.573.574.75.82a3.61 3.61 0 0 1 0 4.19c-.177.246-.417.486-.75.82l-2.84 2.84c-.334.333-.574.573-.82.749a3.61 3.61 0 0 1-4.19 0c-.246-.176-.486-.416-.82-.75l-.054-.054a.84.84 0 1 1 1.188-1.187c.41.41.544.54.66.623.672.477 1.571.477 2.242 0 .117-.084.25-.213.66-.623l2.732-2.732c.41-.41.54-.544.623-.66.478-.671.478-1.57 0-2.241-.083-.117-.213-.251-.623-.662-.41-.41-.544-.54-.661-.623a1.93 1.93 0 0 0-2.24 0c-.118.084-.252.213-.662.623l-1.187 1.188a.84.84 0 1 1-1.188-1.187z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#202020",
      d: "M9.025 16.93c-.334.333-.574.573-.82.749a3.61 3.61 0 0 1-4.19 0c-.246-.176-.486-.416-.82-.75l-.108-.108c-.334-.333-.574-.573-.75-.82a3.61 3.61 0 0 1 0-4.189c.176-.247.416-.487.75-.82l2.84-2.84c.333-.334.573-.574.82-.75a3.61 3.61 0 0 1 4.189 0c.247.176.487.416.82.75l.054.054a.84.84 0 0 1-1.187 1.188c-.41-.41-.544-.54-.661-.623a1.93 1.93 0 0 0-2.24 0c-.118.083-.252.213-.662.623L4.33 12.125c-.41.41-.54.544-.623.661a1.93 1.93 0 0 0 0 2.24c.083.118.212.252.623.662.41.41.544.54.66.623.671.477 1.57.477 2.241 0 .117-.083.251-.213.661-.623L9.08 14.5a.84.84 0 0 1 1.187 1.188z"
    }, null, -1)
  ]))]))
}
export default { render: render }